@use "foundation/_colors.scss";

.platform-feedback-card {
  background-color: colors.$secondary-background-color;
  border-radius: .25em;
  margin-bottom: 1em;

  .feedback-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    border-bottom: 2px solid white;
    padding: 1em 1.5em;
    font-size: .8em;

    .feedback-header-container {
      display: inherit;
      align-items: center;
      min-width: 13%;
      max-width: 30%;

      a {
        height: 1.5em;
        width: 1.5em;
        border-radius: 0.75em;
        background-size: 100%;
        margin-right: .5em;

        span {
          display: block;
          height: 1.5em;
          width: 1.5em;
          border-radius: 0.75em;
          background-size: 100%;
        }
      }
      b {
        font-weight: 600;
      }

      .timestamp {
        color: colors.$secondary-text-color;
        margin-right: 1.5em;
      }

      .report-tag {
        font-size: 1em;
        font-weight: 600;
        cursor: pointer;
      }

      .report-tag:active {
        color: colors.$tertiary-text-color;
      }

      .channel-info-container {
        display: inherit;
        align-items: center;
        margin-left: .5em;
        span {
          display: flex;
          align-items: center;
          height: 1.5em;
          margin-left: .5em;
          border-radius: .12em;
          padding: 0 .5em;
          color: white;
          font-weight: bold;
          white-space: nowrap;

          img {
            height: 70%;
            margin-right: 1em;
          }
        }
      }
    }
  }

  .feedback-card-body {
    padding: 1em 1.35em;
    font-size: .9em;
    display: flex;
    align-items: center;

    .thumbs {
      border-radius: 1em;
      width: 2em;
      height: 2em;
      display: inline-flex;
      align-self: baseline;
      align-items: center;
      justify-content: center;
      margin-right: 1em;
      flex-shrink: 0;

      svg {
        stroke: colors.$primary-background-color;
      }
    }

    .up {
      background-color: colors.$success-color;
    }

    .down {
      background-color: colors.$error-color;
    }

    .opinion-text {
      margin: 0.3em auto;
      font-size: 1.1em;

      & + div {
        margin-bottom: 0.5em;

        span:first-child {
          color: colors.$secondary-text-color;
        }

        span:not(:first-child) {
          font-weight: 700;
        }
      }
    }
  }

  .feedback-card-modal {
    width: 32em;

    .feedback-modal-content {
      margin: 0 auto;
      width: 80;
      padding-bottom: 1em;
    }

    .modal-button-container {
      width: 55%;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
    }
  }
}

.platform-feedback-page-container {
  .feedback-page-header {
    margin-bottom: 1em;
  }

  .feedback-nav-container {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .feedback-nav-button {
      font-size: 1em;
      font-weight: bold;
      color: colors.$primary-brand-color;
      cursor: pointer;
    }

    .feedback-nav-button:disabled {
      cursor: not-allowed;
      color: colors.$quaternary-text-color;
    }
  }
}
